import React from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { HEADER_SYSTEM_ALERT_ID } from 'constant'

const BOTPromotionBannerAndModal = ({
  components: {
    BeforeComponent = <></>,
    TimerComponent = <></>,
    AfterComponent = <></>
  } = {},
  isBannerVisible
}) => (
  <>
    {Boolean(isBannerVisible) &&
    <Banner className="promotion-countdown-banner" id={ HEADER_SYSTEM_ALERT_ID }>
      <BannerContentWrapper className="promotion-countdown-banner__content">
        {BeforeComponent}
        {TimerComponent}
        {AfterComponent}
      </BannerContentWrapper>
    </Banner>}
  </>
)

BOTPromotionBannerAndModal.propTypes = {
  components: PropTypes.shape(),
  isBannerVisible: PropTypes.bool
}

const Banner = styled.div`
  display: block;
  width: 100%;
`

const BannerContentWrapper = styled.div`
  display: block;
`

export default BOTPromotionBannerAndModal

